import {getResultInfo} from '@web/actions/result'
import {convertBannerInfo} from '@web/slices/banner/slice'
import makeSlice from '@web/slices/banner/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getResultInfo.fulfilled, (state, {payload: {banners, products}}) => {
            state.bannerArea = convertBannerInfo(banners.bannersByExposureAreaType)
            state.expectedTotalRewardPointOfTodayOrders = banners.expectTotalRewardPointOfTodayOrders ?? 0
            state.membershipRewardPointAmount = banners.membershipRewardPointAmount ?? 0
            state.payMethodType = banners.payMethodType
            state.userName = banners.userName
            state.naverBenefit = products.some(({naverBenefit}) => naverBenefit)
            state.userNickName = banners.userNickName
            state.shouldNoCertificationRender = banners.rightAwayPayBannerExposure ?? false
        })
    },
})

export default slice.reducer

export const actions = slice.actions
